import { render, staticRenderFns } from "./SlideHotspotsPopups.vue?vue&type=template&id=4f081336&scoped=true&"
import script from "./SlideHotspotsPopups.vue?vue&type=script&lang=js&"
export * from "./SlideHotspotsPopups.vue?vue&type=script&lang=js&"
import style0 from "./SlideHotspotsPopups.vue?vue&type=style&index=0&id=4f081336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f081336",
  null
  
)

export default component.exports